import { actionTypes } from './actions'

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.RECEIVED_WIDGET:
      return {
        ...action.payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/pages/widgets/form-actions/edit/reducer.js